import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { openAdvancedSettings } from "../../_actions/sidebarSliderActions";
import { ADVANCED_COMMENTS_PANEL } from "../details/constants";
import { Box, Button, Flex, IconButton, Tooltip } from "@chakra-ui/react";
import { FaComment } from "react-icons/fa";
import { BadgeCount } from "../common/BadgeCount";
import { withTranslation } from "react-i18next";

class TldrCommentDropdown extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);

    this.state = {
      isDropdownOpen: false,
    };
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.toggleDropdown();
    }
  }

  toggleDropdown = () => {
    this.props.openAdvancedSettings(ADVANCED_COMMENTS_PANEL);
  };

  render() {
    // const { isActionPanelOpen, sliderPanelType } = this.props.rightsidebar;
    const { t } = this.props;

    return (
      <>
        <Flex display={["none", "none", "block"]}>
          <Tooltip hasArrow label={t("comments.dropdown.tooltip")}>
            <IconButton
              position="relative"
              onClick={this.toggleDropdown}
              size="sm"
              fontSize="lg"
              variant="ghost"
              icon={
                <>
                  <FaComment />
                 {this.props.commentCount>0 &&
                  <Box
                    height={2}
                    width={2}
                    background="brand.primary"
                    display="inline-block"
                    borderRadius="full"
                    position="absolute"
                    right="4px"
                    bottom="6px"
                  />
                 }
                </>
              }
              _focus={{ color: "none" }}
              _active={{ color: "none" }}
            />
          </Tooltip>
        </Flex>

        <Flex display={["inline-block", "inline-block", "none"]}>
          <Button
            onClick={this.toggleDropdown}
            leftIcon={<FaComment />}
            variant="unstyled"
            ml={8}
            fontWeight={400}
            iconSpacing={8}
          >
            {t("comments.dropdown.comments")}
          </Button>
        </Flex>
      </>
    );
  }
}

TldrCommentDropdown.propTypes = {};

const mapStateToProps = (state) => ({
  auth: state.auth,
  activePage: state.editor.activePage,
  activeElement: state.editor.activeElement,
  pagestore: state.pagestore,
  layerstore: state.layerstore,
  commentCount: state.comment.commentCount,
  rightsidebar: state.rightsidebar,
});

const mapDispatchToProps = (dispatch) => ({
  openAdvancedSettings: (panel, selectedTab) =>
    dispatch(openAdvancedSettings(panel, selectedTab)),
});

export default withTranslation(["navbar"])(
  connect(mapStateToProps, mapDispatchToProps)(TldrCommentDropdown)
);
